import { FileFormats } from "../../../../../../../../components/finalForms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../../../components/finalForms/libs/data/ValidationTypes";

const initState = {
  attachments: null,
};

export const synergyattachmentForm = {
  name: "Attachments",
  initialState: initState,

  section: [
    {
      sectionId: 'addAttachments',
      title: "Add Attachments",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "attachments",
          label: "Synergy Attachments",
          Field_Name: "attachments",
          fieldType: FormFieldTypes.FILE,
          dataField: "attachments",
          fieldSetting: {
            placeholder: "Upload File",
            allowMultipleFiles: false,
            acceptedFileFormats: [
              FileFormats.ALL,
              // ImageFormats.ANY
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 8, // Maximum File size in MB
          },
          validation: [{ type: validationTypes.FILE }],
          style: {
            containerCss:
              "col-lg-12 col-md-3 mb-2  profile-pic-upload file-upload validation-left-0 attachment",
          },
        },
      ]
    }
  ]
};

